import { render, staticRenderFns } from "./QuestionnaireRecoverData.vue?vue&type=template&id=08d7602e&scoped=true&"
import script from "./QuestionnaireRecoverData.vue?vue&type=script&lang=js&"
export * from "./QuestionnaireRecoverData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08d7602e",
  null
  
)

export default component.exports